import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import dt from '../../../shared/theme';

export default function Type({ type }) {
  const TypeContainer = styled.div`
    > span {
      color: ${props => dt(props).theme.primaryColor};
      font-family: ${props => dt(props).theme.fontFamilyBody};
      font-weight: ${props => dt(props).theme.fontWeightHeavy};
      font-size: 10px;
      line-height: 120%;
      text-transform: uppercase;
      padding: 2px 6px;
      border-radius: 2px;
    
      ${props => dt(props).theme.isXXLarge && `
        font-size: 11px;
      `};
    
      &.managed-fund {
        color: #2563EB;
        background-color: #EFF6FF;
      }
  
      &.etf {
        color: #047857;
        background-color: #D1FAE5;
      }
  
      &.lit {
        color: #6D28D9;
        background-color: #EDE9FE;
      }
  
      &.lic {
        color: #A21CAF;
        background-color: #FAE8FF;
      }
    }
  `;

  const typeClass = type.toLowerCase().replace(' ', '-');

  return (
    <TypeContainer>
      <span className={typeClass}>{type}</span>
    </TypeContainer>
  );
}

Type.propTypes = {
  type: PropTypes.string.isRequired,
};
